import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./App.css";
import "./supertokens";
import SuperTokens from "supertokens-auth-react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { AuthProvider } from "./contexts";
import { UploadQueueProvider } from "./contexts/UploadQueueContext";

type NavigatorWithStandalone = Navigator & { standalone?: boolean };

const isStandalone =
  window.matchMedia?.("(display-mode: standalone)")?.matches === true ||
  (navigator as NavigatorWithStandalone).standalone === true;

if (isStandalone) {
  document.documentElement.classList.add("pwa-standalone");
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (previously cacheTime)
      retry: (failureCount, error) => {
        const message = error instanceof Error ? error.message.toLowerCase() : "";
        if (
          message.includes("session verification failed") ||
          message.includes("user not authenticated") ||
          message.includes("no active session") ||
          message.includes("http error! status: 401") ||
          message.includes("http error! status: 403")
        ) {
          return false;
        }
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <SuperTokens.SuperTokensWrapper>
        <AuthProvider>
          <UploadQueueProvider>
            <App />
            <ReactQueryDevtools initialIsOpen={false} />
          </UploadQueueProvider>
        </AuthProvider>
      </SuperTokens.SuperTokensWrapper>
    </QueryClientProvider>
  </React.StrictMode>
);
